import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const TOKEN_KEY = "casamore_token";

export const fileUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND}${u}`);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
